'use client';

import type { ReactNode } from 'react';
import { trackFunnelEvent, FUNNEL_EVENTS } from '@/lib/analytics/events';
import type { VerticalId } from '@/lib/verticals/verticalRegistry';

/**
 * Fires the `select_vertical` event when a card on the industry chooser is
 * followed, so the funnel shows which lane actually converts rather than just
 * counting the chooser as one step.
 *
 * The card itself stays a plain server-rendered <Link> so the four vertical
 * links remain crawlable in the initial HTML — this wrapper adds no DOM and no
 * client-side navigation, so it costs nothing for SEO and nothing for speed.
 */
export function ChooseIndustryClient({
  verticalId,
  industryLabel,
  children,
}: {
  verticalId: string;
  industryLabel: string;
  children: ReactNode;
}) {
  return (
    <span
      onClick={() =>
        trackFunnelEvent(FUNNEL_EVENTS.selectVertical, {
          vertical: verticalId,
          cta: 'industry_chooser_card',
          industry: industryLabel,
        })
      }
    >
      {children}
    </span>
  );
}

/** Per-vertical accent tints for the chooser cards, keyed by registry id. */
export const CHOOSER_CARD_COLORS: Record<string, { accent: string; tint: string }> = {
  stay: { accent: '#E5448D', tint: '#fdf2f8' },
  fixit: { accent: '#1B93EA', tint: '#eff7fe' },
  restaurant: { accent: '#E5448D', tint: '#fdf2f8' },
  retail: { accent: '#11C629', tint: '#f2fdf4' },
  'professional-services': { accent: '#001489', tint: '#f8fbff' },
};

export type { VerticalId };
